import { render, staticRenderFns } from "./JsonObject.vue?vue&type=template&id=bf65d2e6&scoped=true&"
import script from "./JsonObject.vue?vue&type=script&lang=js&"
export * from "./JsonObject.vue?vue&type=script&lang=js&"
import style0 from "./JsonObject.vue?vue&type=style&index=0&id=bf65d2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf65d2e6",
  null
  
)

export default component.exports